module.exports = "<div id=\"injectedPasswordRecovery\" ng-show=\"loaded\">\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ../node_modules/xo-login-components/src/password-recovery/template.html
// module id = ../node_modules/xo-login-components/src/password-recovery/template.html
// module chunks = 0